module.exports = __webpack_public_path__ + "static/img/Completed.be59011.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Completed.png
// module id = 1279
// module chunks = 7